<template>
  <router-link replace :to="{ name: 'contentViewer', query: { page_uri: '/about' } }" class="text-decoration-none">
    <div class="pa-4 w-100 text-center bg-primary guide-button">
      <v-icon class="mr-3" :style="{fontSize:'42px'}">mdi-leaf</v-icon>
      <div class="text-left" :style="{lineHeight:'20px'}">
        <img src="/images/securite_logo_white.png" width="50" /><br>
        はじめてガイド
      </div>
    </div>
  </router-link>
</template>

<script>
  export default {
    name: 'GuideButton',
    components: {
    },
    data() {
      return {
      }
    },
    // コンポーネントマウントリスナ
    async mounted() {
    },
    methods: {
    }
  }
</script>

<style scoped>
  .guide-button {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>